import { Enum } from '@lighthouse/tools'

import type { BlockType, PageStateWithValue } from '../abstracts'
import type { SelectedMode } from './view'

export type PageId = string

/** @deprecated */
export type ContainerPanelMap = {
    [blockId: string]: {
        // 全局模板状态，用于：
        // 1. 非自定义视图场景的实际状态
        // 2. 外部场景（页面层级树等）的预览显示
        // 3. 自定义视图中新记录的初始状态
        currentView: string
        // 自定义视图内按 recordId 隔离的运行时状态
        // 每条记录可以独立切换面板，互不影响
        recordStates?: {
            [recordId: string]: {
                currentView: string
            }
        }
    }
}

/** @deprecated 所有block运行时的状态迁移到这里 */
export type BlockRuntimeState = {
    [BlockType.container]?: ContainerPanelMap
    [BlockType.tabs]?: {
        [blockId: string]: {
            // 当前tab
            currentTab: string
        }
    }
    [BlockType.formContainer]?: {
        [blockId: string]: {
            // 当前tab
            changed: boolean
        }
    }
    [BlockType.view]?: {
        viewId: string
        scope?: string
        selectedIds: string[]
        selectedMode?: SelectedMode
    }
}

export const PAGE_STACK_DISPLAY_TYPE = Enum('modal', 'drawer', 'page')
/** 记录页面打开方式 */
export type PageStackDisplayType = Enum<typeof PAGE_STACK_DISPLAY_TYPE>

/** 不是name，是id */
type QueryId = string

/**
 * 页面栈元信息
 */
export interface BasicPageStackMeta {
    pageId: string
    stackId: string
    /** stack的显示形式 */
    pageStackDisplayType: PageStackDisplayType
    /** 页面路径参数 */
    pagePathParameters?: string[]
    /** 页面查询参数 */
    pageQueryParameters?: Record<QueryId, string>
    /** 锚点 hash，用于滚动到指定组件 */
    hash?: string
}

export interface PageStackTree extends BasicPageStackMeta {
    children?: PageStackTree[]
}

export interface ContainerRuntimeState {
    // 全局模板状态，用于：
    // 1. 非自定义视图场景的实际状态
    // 2. 外部场景（页面层级树等）的预览显示
    // 3. 自定义视图中新记录的初始状态
    currentView: string
    // 自定义视图内按 recordId 隔离的运行时状态
    // 每条记录可以独立切换面板，互不影响
    recordStates?: {
        [recordId: string]: {
            currentView: string
        }
    }
}

export interface ViewRuntimeState {
    viewId: string
    scope?: string
    selectedIds: string[]
    selectedMode?: SelectedMode
}
